import { useState, useEffect } from "react";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import axios from "axios";
import { Box, Typography, Chip, Avatar, Breadcrumbs, Link } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { MascaraCpf } from "../../../utils/MascaraCpf";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import { MascaraCep } from "../../../utils/MascaraCep";
import { TirarMascara } from "../../../utils/TirarMascara";
import AlertSuccess from "../../components/AlertSuccess";
import AlertError from "../../components/AlertError";

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const campoSx = {
    "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" },
};

const linhaCamposSx = (colunas) => ({
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: colunas },
    gap: 1.5,
});

// Definido fora do componente para não remontar os inputs (e perder o foco) a cada render
const SecaoCard = ({ icone, titulo, descricao, children }) => (
    <Box sx={cardSx}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
            <Box
                sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "8px",
                    backgroundColor: "#f3f4f6",
                    color: "#374151",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    "& svg": { fontSize: 20 },
                }}
            >
                {icone}
            </Box>
            <Box>
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>{titulo}</Typography>
                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{descricao}</Typography>
            </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>{children}</Box>
    </Box>
);

const InfoLinha = ({ icone, texto }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        <Box sx={{ display: "flex", color: "#94a3b8", "& svg": { fontSize: 16 } }}>{icone}</Box>
        <Typography noWrap sx={{ fontSize: 13, color: "#cbd5e1" }}>{texto}</Typography>
    </Box>
);

const semMascara = (valor) => TirarMascara(String(valor ?? ""));

const valoresDoUsuario = (user) => ({
    nome: user?.usuario?.nome || "",
    email: user?.usuario?.email || "",
    cpf: user?.usuario?.cpf || "",
    cnpj: user?.usuario?.cnpj || "",
    razaoSocial: user?.usuario?.razaoSocial || "",
    telefone: user?.usuario?.telefone || "",
    endereco: user?.endereco?.endereco || "",
    numero: user?.endereco?.numero || "",
    cep: user?.endereco?.cep || "",
    cidade: user?.endereco?.cidade || "",
    estado: user?.endereco?.estado || "",
    complemento: user?.endereco?.complemento || "",
    bairro: user?.endereco?.bairro || "",
});

const camposComMascara = ["Cpf", "Cnpj", "Telefone", "Cep"];

const PerfilDashboard = () => {

    const [userActive, setUserActive] = useState(true);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { user } = useUser();

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [cpf, setCpf] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [razaoSocial, setRazaoSocial] = useState("");
    const [telefone, setTelefone] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [cep, setCep] = useState("");
    const [complemento, setComplemento] = useState("");
    const [valoresSalvos, setValoresSalvos] = useState(valoresDoUsuario(null));
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");


    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!token) navigate("../Login");
    }, [token, navigate]);

    const preencherCampos = (valores) => {
        setNome(valores.nome);
        setEmail(valores.email);
        setCpf(valores.cpf);
        setCnpj(valores.cnpj);
        setRazaoSocial(valores.razaoSocial);
        setTelefone(valores.telefone);
        setEndereco(valores.endereco);
        setNumero(valores.numero);
        setCep(valores.cep);
        setCidade(valores.cidade);
        setEstado(valores.estado);
        setComplemento(valores.complemento);
        setBairro(valores.bairro);
    };

    useEffect(() => {
        if (!user) {
            setOpen(true);
            return;
        }
        const valores = valoresDoUsuario(user);
        preencherCampos(valores);
        setValoresSalvos(valores);
        setOpen(false);
    }, [user]);

    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;
        setUserActive(!hasFaturasVencidas);
    }, [user]);

    const valoresAtuais = { nome: nome, email: email, cpf: cpf, cnpj: cnpj, razaoSocial: razaoSocial, telefone: telefone, endereco: endereco, numero: numero, cep: cep, cidade: cidade, estado: estado, complemento: complemento, bairro: bairro };
    const hasChange = Object.keys(valoresAtuais).some((campo) =>
        camposComMascara.includes(campo)
            ? semMascara(valoresAtuais[campo]) !== semMascara(valoresSalvos[campo])
            : String(valoresAtuais[campo] ?? "") !== String(valoresSalvos[campo] ?? "")
    );

    const handleSaveChanges = async () => {
        setOpen(true)
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/atualizarPerfil`, {
                nome,
                email,
                cpf: TirarMascara(cpf),
                cnpj: TirarMascara(cnpj),
                razaoSocial,
                telefone: TirarMascara(telefone),
                rua: endereco,
                numero,
                bairro,
                cidade,
                estado,
                cep: TirarMascara(cep),
                complemento
            }, {
                headers: { Authorization: token }
            });

            if (response.data.status === 200) {
                setValoresSalvos(valoresAtuais);
                setMensagem("Perfil atualizado com sucesso");
                setOpenSnackbarSuccess(true);
            } else {
                setMensagem("Erro ao atualizar perfil");
                setOpenSnackbarError(true);
            }
        } catch (error) {
            console.error("Erro ao atualizar perfil:", error?.response || error);
            setMensagem("Erro ao atualizar perfil. Tente novamente mais tarde.");
            setOpenSnackbarError(true);
        } finally {
            setOpen(false);
        }
    }

    const isPessoaFisica = user?.usuario?.tipoPessoa === "Fisica";
    const isPessoaJuridica = user?.usuario?.tipoPessoa === "Juridica";
    const iniciais = (valoresSalvos.nome || "").split(" ").filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");

    const atalhos = [
        { label: "Gerenciar plano", icone: <DisplaySettingsIcon />, rota: "../Dashboard/Assinatura" },
        { label: "Minhas faturas", icone: <CreditCardIcon />, rota: "../Dashboard/Faturas/Pendentes" },
        { label: "Ficha cadastral dos sócios", icone: <AssignmentIndOutlinedIcon />, rota: "../Dashboard/FichaCadastral" },
    ];

    return (
        <>
            <HeaderDashboard userActive={userActive} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <PersonIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Meu Perfil
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Meu Perfil
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Mantenha seus dados pessoais e de endereço sempre atualizados.
                        </Typography>
                    </Box>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate(-1)}
                        sx={{ alignSelf: { xs: "flex-start", md: "center" }, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                    >
                        Voltar
                    </Button>
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1.2fr) minmax(0, 3fr)" },
                        gap: 2,
                        alignItems: "start",
                    }}
                >
                    {/* Resumo do perfil */}
                    <Box sx={{ position: { md: "sticky" }, top: { md: 80 }, display: "flex", flexDirection: "column", gap: 2 }}>
                        <Box sx={{ ...cardSx, backgroundColor: "#0b243d", border: "none", color: "#fff" }}>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                                <Avatar sx={{ width: 72, height: 72, fontSize: 24, fontWeight: 700, color: "#0b243d", backgroundColor: "#ffc845" }}>
                                    {iniciais || <PersonIcon />}
                                </Avatar>
                                <Typography sx={{ mt: 1.5, fontSize: 18, fontWeight: 700, wordBreak: "break-word" }}>
                                    {valoresSalvos.nome || "Seu nome"}
                                </Typography>
                                {(isPessoaFisica || isPessoaJuridica) && (
                                    <Chip
                                        label={isPessoaFisica ? "Pessoa física" : "Pessoa jurídica"}
                                        size="small"
                                        sx={{ mt: 1, backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                                    />
                                )}
                            </Box>

                            <Box sx={{ mt: 2.5, display: "flex", flexDirection: "column", gap: 1, backgroundColor: "rgba(255, 255, 255, 0.06)", borderRadius: "10px", p: 1.5 }}>
                                <InfoLinha icone={<MailOutlineIcon />} texto={valoresSalvos.email || "E-mail não informado"} />
                                <InfoLinha icone={<PhoneOutlinedIcon />} texto={valoresSalvos.telefone ? MascaraTelefone(valoresSalvos.telefone) : "Telefone não informado"} />
                                <InfoLinha
                                    icone={<BadgeOutlinedIcon />}
                                    texto={isPessoaFisica
                                        ? (valoresSalvos.cpf ? `CPF: ${MascaraCpf(valoresSalvos.cpf)}` : "CPF não informado")
                                        : (valoresSalvos.cnpj ? `CNPJ: ${MascaraCnpj(valoresSalvos.cnpj)}` : "CNPJ não informado")}
                                />
                            </Box>
                        </Box>

                        <Box sx={{ ...cardSx, p: 1 }}>
                            {atalhos.map((atalho) => (
                                <Box
                                    key={atalho.label}
                                    onClick={() => navigate(atalho.rota)}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        px: 1.5,
                                        py: 1.25,
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        "&:hover": { backgroundColor: "#f3f4f6" },
                                    }}
                                >
                                    <Box sx={{ display: "flex", color: "#6b7280", "& svg": { fontSize: 18 } }}>{atalho.icone}</Box>
                                    <Typography sx={{ flex: 1, fontSize: 13, fontWeight: 600, color: "#374151" }}>{atalho.label}</Typography>
                                    <ChevronRightIcon sx={{ fontSize: 18, color: "#9ca3af" }} />
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    {/* Formulário */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <SecaoCard icone={<PersonOutlineIcon />} titulo="Dados Pessoais" descricao="Informações de identificação e contato">
                            <TextField fullWidth label="Nome" value={nome} onChange={(e) => setNome(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                            <TextField fullWidth label="E-mail" value={email} disabled size="small" variant="outlined" sx={campoSx} helperText="O e-mail de acesso não pode ser alterado por aqui." />
                            <Box sx={linhaCamposSx("1fr 1fr")}>
                                {isPessoaFisica ? (
                                    <TextField fullWidth label="CPF" value={MascaraCpf(cpf)} onChange={(e) => setCpf(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                                ) : (
                                    <TextField fullWidth label="CNPJ" value={MascaraCnpj(cnpj)} onChange={(e) => setCnpj(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                                )}
                                <TextField fullWidth label="Telefone" value={MascaraTelefone(telefone)} onChange={(e) => setTelefone(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                            </Box>
                            {isPessoaJuridica && (
                                <TextField fullWidth label="Razão social" value={razaoSocial} onChange={(e) => setRazaoSocial(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                            )}
                        </SecaoCard>

                        <SecaoCard icone={<LocationOnOutlinedIcon />} titulo="Dados de Endereço" descricao="Endereço usado no seu cadastro">
                            <Box sx={linhaCamposSx("1fr 2fr 0.7fr")}>
                                <TextField fullWidth label="CEP" value={MascaraCep(cep)} onChange={(e) => setCep(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                                <TextField fullWidth label="Nome da rua" value={endereco} onChange={(e) => setEndereco(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                                <TextField fullWidth label="Número" value={numero} onChange={(e) => setNumero(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                            </Box>
                            <Box sx={linhaCamposSx("1fr 1fr 1fr")}>
                                <TextField fullWidth label="Bairro" value={bairro} onChange={(e) => setBairro(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                                <TextField fullWidth label="Cidade" value={cidade} onChange={(e) => setCidade(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                                <TextField fullWidth label="Estado" value={estado} onChange={(e) => setEstado(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                            </Box>
                            <TextField fullWidth label="Complemento" value={complemento} onChange={(e) => setComplemento(e.target.value)} size="small" variant="outlined" sx={campoSx} />
                        </SecaoCard>

                        <Box
                            sx={{
                                ...cardSx,
                                p: 2,
                                position: "sticky",
                                bottom: 16,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1.5,
                                flexWrap: "wrap",
                                borderColor: hasChange ? "#ffc845" : "#e5e7eb",
                            }}
                        >
                            <Typography sx={{ fontSize: 13, color: hasChange ? "#b45309" : "#6b7280", fontWeight: hasChange ? 600 : 400 }}>
                                {hasChange ? "Você tem alterações não salvas." : "Todos os dados estão salvos."}
                            </Typography>
                            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                <Button
                                    disabled={!hasChange}
                                    onClick={() => preencherCampos(valoresSalvos)}
                                    sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                                >
                                    Descartar
                                </Button>
                                <Button
                                    variant="contained"
                                    startIcon={<SaveOutlinedIcon />}
                                    disabled={!hasChange}
                                    onClick={handleSaveChanges}
                                    sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", px: 2, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } }}
                                >
                                    Salvar alterações
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Loading open={open} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
        </>
    );
};

export default PerfilDashboard;
